/**
 * Zeigereffekte für App und Warteliste – nur mit Maus und ohne „Bewegung reduzieren“:
 * Licht folgt dem Zeiger (--mx/--my), die Szene neigt sich leicht (--rx/--ry) und Buttons ziehen
 * sich magnetisch zum Zeiger hin (--tx/--ty). Die Werte landen als CSS-Variablen am Element.
 */

function allowed(): boolean {
  return (
    window.matchMedia('(pointer: fine)').matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

export function attachPointerLight(element: HTMLElement, maxTiltDeg = 6): () => void {
  if (!allowed()) return () => {};
  let frame = 0;

  const onMove = (event: PointerEvent) => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const rect = element.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      element.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
      element.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
      element.style.setProperty('--rx', `${((x - 0.5) * maxTiltDeg).toFixed(2)}deg`);
      element.style.setProperty('--ry', `${((0.5 - y) * maxTiltDeg).toFixed(2)}deg`);
    });
  };
  const onLeave = () => {
    cancelAnimationFrame(frame);
    element.style.setProperty('--rx', '0deg');
    element.style.setProperty('--ry', '0deg');
  };

  element.addEventListener('pointermove', onMove);
  element.addEventListener('pointerleave', onLeave);
  return () => {
    cancelAnimationFrame(frame);
    element.removeEventListener('pointermove', onMove);
    element.removeEventListener('pointerleave', onLeave);
  };
}

export function attachMagnetic(element: HTMLElement, strength = 0.22): () => void {
  if (!allowed()) return () => {};

  const onMove = (event: PointerEvent) => {
    const rect = element.getBoundingClientRect();
    const dx = event.clientX - (rect.left + rect.width / 2);
    const dy = event.clientY - (rect.top + rect.height / 2);
    element.style.setProperty('--tx', `${(dx * strength).toFixed(1)}px`);
    element.style.setProperty('--ty', `${(dy * strength).toFixed(1)}px`);
  };
  const onLeave = () => {
    element.style.setProperty('--tx', '0px');
    element.style.setProperty('--ty', '0px');
  };

  element.addEventListener('pointermove', onMove);
  element.addEventListener('pointerleave', onLeave);
  return () => {
    element.removeEventListener('pointermove', onMove);
    element.removeEventListener('pointerleave', onLeave);
  };
}
